import { type Href, router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';

import Home from '../../../home/components/Home';

export default function HomeTab() {
    // If this query param is populated, we need to navigate to it from this page.
    // This, along with the code that populates this param, ensures any deep-linked
    // modal routes are able to open correctly as modals "on top of" the home route.
    const { goToModalRoute } = useLocalSearchParams();
    if (goToModalRoute !== undefined) {
        router.navigate(goToModalRoute as Href);
    }

    return <Home />;
}
